import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לתפקיד",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה לשנות את התפקיד.",
      "אני רק שם/ה לב אליו.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה לשנות את התפקיד.",
      "אני רק שם/ה לב אליו.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני מרגיש/ה שאני רק מקשיב/ה?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ],
      [
      "מתי אני מרגיש/ה שאני רק מקשיב/ה?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב לתפקיד הוא כבר התחלה."
    ],
      [
      "לשים לב לתפקיד הוא כבר התחלה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה נשאר בי",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שנשאר בי אחרי שאני מקשיב/ה.",
      "בלי שיפוט.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב למה שנשאר בי אחרי שאני מקשיב/ה.",
      "בלי שיפוט.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני לא אומר/ת בדרך כלל?",
      "מה אני שומר/ת בפנים?",
      "איך זה משפיע עליי?"
    ],
      [
      "מה אני לא אומר/ת בדרך כלל?",
      "מה אני שומר/ת בפנים?",
      "איך זה משפיע עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מה שנשאר בי חשוב."
    ],
      [
      "מה שנשאר בי חשוב."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על מה שנשאר.",
      "לכתוב מילה אחת על מה שנשאר."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "למה אני בוחר/ת להקשיב",
    opening: localizedGenderNode(
      [
      "היום אני שואל/ת למה אני בוחר/ת להקשיב כל כך.",
      "לא ביקורת.",
      "סקרנות."
    ],
      [
      "היום אני שואל/ת למה אני בוחר/ת להקשיב כל כך.",
      "לא ביקורת.",
      "סקרנות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מקבל/ת כשאני מקשיב/ה?",
      "מה אני מפחד/ת לאבד אם אדבר?",
      "מה הצורך שמתחת לזה?"
    ],
      [
      "מה אני מקבל/ת כשאני מקשיב/ה?",
      "מה אני מפחד/ת לאבד אם אדבר?",
      "מה הצורך שמתחת לזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "יש סיבה עדינה מאחורי ההקשבה."
    ],
      [
      "יש סיבה עדינה מאחורי ההקשבה."
    ]
    ),
    action: localizedGenderNode(
      "לזהות צורך אחד קטן.",
      "לזהות צורך אחד קטן."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "מקום לקול שלי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך לתת מקום לקול שלי.",
      "קטן.",
      "בטוח."
    ],
      [
      "היום אני בודק/ת איך לתת מקום לקול שלי.",
      "קטן.",
      "בטוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הגרון."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הגרון."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אפשר לתת לי מקום לדבר?",
      "מה אני מפחד/ת לומר?",
      "מה צעד קטן שאפשר לעשות?"
    ],
      [
      "איפה אפשר לתת לי מקום לדבר?",
      "מה אני מפחד/ת לומר?",
      "מה צעד קטן שאפשר לעשות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מקום קטן לקול שלי כבר משנה משהו."
    ],
      [
      "מקום קטן לקול שלי כבר משנה משהו."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב משפט אחד שהיה רוצה לצאת.",
      "לכתוב משפט אחד שהיה רוצה לצאת."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הפחד להכביד",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לפחד להכביד.",
      "לא להילחם.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב לפחד להכביד.",
      "לא להילחם.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מפחד/ת כשאני משתף/ת?",
      "מה אני חושב/ת שיקרה אם אדבר?",
      "איך הפחד הזה שומר עליי?"
    ],
      [
      "ממה אני מפחד/ת כשאני משתף/ת?",
      "מה אני חושב/ת שיקרה אם אדבר?",
      "איך הפחד הזה שומר עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פחד להכביד הוא גם רצון לשמור על קשר."
    ],
      [
      "פחד להכביד הוא גם רצון לשמור על קשר."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני רואה אותך\".",
      "לומר לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "איזון קטן",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך ליצור איזון קטן.",
      "לא מושלם.",
      "רק קטן."
    ],
      [
      "היום אני בודק/ת איך ליצור איזון קטן.",
      "לא מושלם.",
      "רק קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני נותן/ת יותר ממה שאני מקבל/ת?",
      "מה הייתי רוצה לקבל קצת יותר?",
      "מה צעד קטן שאפשר לעשות?"
    ],
      [
      "איפה אני נותן/ת יותר ממה שאני מקבל/ת?",
      "מה הייתי רוצה לקבל קצת יותר?",
      "מה צעד קטן שאפשר לעשות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "איזון קטן יכול להחזיר אנרגיה."
    ],
      [
      "איזון קטן יכול להחזיר אנרגיה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב בקשה אחת קטנה.",
      "לכתוב בקשה אחת קטנה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "להישאר כשאני מדבר/ת",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר כשאני מדבר/ת.",
      "לא להיעלם.",
      "רק להיות."
    ],
      [
      "היום אני מתרגל/ת להישאר כשאני מדבר/ת.",
      "לא להיעלם.",
      "רק להיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני ממהר/ת לסיים?",
      "מה מפחיד אותי אם אשאר?",
      "מה יקרה אם אשאר עוד 10 שניות?"
    ],
      [
      "מתי אני ממהר/ת לסיים?",
      "מה מפחיד אותי אם אשאר?",
      "מה יקרה אם אשאר עוד 10 שניות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עוד רגע אחד יכול לשנות משהו."
    ],
      [
      "עוד רגע אחד יכול לשנות משהו."
    ]
    ),
    action: localizedGenderNode(
      "לעצור 10 שניות לפני שאני נסוג/ת.",
      "לעצור 10 שניות לפני שאני נסוג/ת."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "מילה אחת שלי",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת מילה אחת שלי לשיתוף.",
      "לא הרבה.",
      "מילה אחת."
    ],
      [
      "היום אני בוחר/ת מילה אחת שלי לשיתוף.",
      "לא הרבה.",
      "מילה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו מילה רוצה לצאת ממני?",
      "למי הייתי רוצה לומר אותה?",
      "איך זה ירגיש לי לומר אותה?"
    ],
      [
      "איזו מילה רוצה לצאת ממני?",
      "למי הייתי רוצה לומר אותה?",
      "איך זה ירגיש לי לומר אותה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מילה אחת יכולה לפתוח דלת."
    ],
      [
      "מילה אחת יכולה לפתוח דלת."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את המילה ולזכור אותה.",
      "לכתוב את המילה ולזכור אותה."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "בקשה אחת",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה אחת קטנה.",
      "לא דרישה.",
      "בקשה."
    ],
      [
      "היום אני מנסח/ת בקשה אחת קטנה.",
      "לא דרישה.",
      "בקשה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הייתי רוצה לבקש בעדינות?",
      "איך אפשר לומר זאת ברוך?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "מה הייתי רוצה לבקש בעדינות?",
      "איך אפשר לומר זאת ברוך?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לשנות קצב."
    ],
      [
      "בקשה אחת יכולה לשנות קצב."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "להרגיש שמקשיבים",
    opening: localizedGenderNode(
      [
      "היום אני שואל/ת מה גורם לי להרגיש שמקשיבים לי.",
      "מעט.",
      "אבל חשוב."
    ],
      [
      "היום אני שואל/ת מה גורם לי להרגיש שמקשיבים לי.",
      "מעט.",
      "אבל חשוב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני כאן."
    ],
      [
      "אני נושם/ת לאט.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך זה מרגיש כשמקשיבים לי באמת?",
      "מה הייתי רוצה לקבל שם?",
      "מה צעד קטן שיכול לעזור?"
    ],
      [
      "איך זה מרגיש כשמקשיבים לי באמת?",
      "מה הייתי רוצה לקבל שם?",
      "מה צעד קטן שיכול לעזור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להרגיש שמקשיבים הוא צורך אמיתי."
    ],
      [
      "להרגיש שמקשיבים הוא צורך אמיתי."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על מה שאני בוחר/ת/ה לשמוע.",
      "לכתוב מילה אחת על מה שאני בוחר/ת/ה לשמוע."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "ערך אחד בקשר",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת ערך אחד שאני מביא/ה לקשר.",
      "קטן.",
      "אבל אמיתי."
    ],
      [
      "היום אני מחפש/ת ערך אחד שאני מביא/ה לקשר.",
      "קטן.",
      "אבל אמיתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך חשוב לי בקשר?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ],
      [
      "איזה ערך חשוב לי בקשר?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך אחד הוא חוט של נוכחות."
    ],
      [
      "ערך אחד הוא חוט של נוכחות."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שמבטאת את הערך.",
      "מילה אחת שמבטאת את הערך."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "להקשיב גם לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להקשיב גם לעצמי.",
      "לא רק לאחרים.",
      "גם לי."
    ],
      [
      "היום אני מתרגל/ת להקשיב גם לעצמי.",
      "לא רק לאחרים.",
      "גם לי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה לשמוע מעצמי היום?",
      "מה אני נותן/ת לאחרים שאני לא נותן/ת לי?",
      "איך אפשר לתת את זה לעצמי?"
    ],
      [
      "מה אני בוחר/ת/ה לשמוע מעצמי היום?",
      "מה אני נותן/ת לאחרים שאני לא נותן/ת לי?",
      "איך אפשר לתת את זה לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להקשיב לעצמי הוא תיקון קטן."
    ],
      [
      "להקשיב לעצמי הוא תיקון קטן."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד עדין לעצמי.",
      "משפט אחד עדין לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן של הדדיות",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן של הדדיות.",
      "לא דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן של הדדיות.",
      "לא דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן מספיק כדי לזוז."
    ],
      [
      "צעד קטן מספיק כדי לזוז."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי להדדיות.",
      "כשאני שוכח/ת אותי.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי להדדיות.",
      "כשאני שוכח/ת אותי.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על ההקשבה שלי?",
      "מה הסימן הראשון שאני נעלם/ת?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על ההקשבה שלי?",
      "מה הסימן הראשון שאני נעלם/ת?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להקשיב לאחרים ולהישאר עם עצמי."
    ],
      [
      "אני יכול/ה להקשיב לאחרים ולהישאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const iMAlwaysTheOneWhoListensToEveryoneButWhoListensToMeBlueprintHe = buildNormalizedPilotBlueprint({
  id: "i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "i_m_always_the_one_who_listens_to_everyone_but_who_listens_to_me",
  category: "loneliness_belonging",
  journeyName: {
    he: "אני תמיד זה שמקשיב לכולם - אבל מי מקשיב לי?",
    en: "I'm always the one who listens to everyone - but who listens to me?",
    es: "Siempre soy quien escucha a todos - ¿pero quién me escucha a mí?",
  },
  days,
});

export default iMAlwaysTheOneWhoListensToEveryoneButWhoListensToMeBlueprintHe;
